import {Col, Row, Tabs} from "antd";
import {StyledPayoutTabsPageWrapper, StyledPayoutTabsWrapper} from "./styles";
import {PayoutPageTabsData} from "./data";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";

type TabKeys = "withdrawal" | "payout" | "transaction";

export function PayoutPageTabs() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab");
  const [defaultActiveKey, setDefaultActiveKey] = useState<TabKeys>("withdrawal");
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab) {
      if (activeTab === "payout") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "transaction") {
        setDefaultActiveKey(activeTab);
      }
      // setDefaultActiveKey("withdrawal");
    }
  }, [activeTab]);

  function handleTabClick(key: string) {
    if (key === "withdrawal") {
      setDefaultActiveKey("withdrawal");
      navigate("/payouts?activeTab=withdrawal");
    }
    if (key === "payout") {
      setDefaultActiveKey("payout");
      navigate("/payouts?activeTab=payout");
    }
    if (key === "transaction") {
      setDefaultActiveKey("transaction");
      navigate("/payouts?activeTab=transaction");
    }
  }
  return (
    <StyledPayoutTabsWrapper>
      <Tabs
        defaultActiveKey={defaultActiveKey}
        activeKey={defaultActiveKey}
        onTabClick={(key) => handleTabClick(key)}
      >
        {PayoutPageTabsData.map((tabData) => (
          <Tabs.TabPane tab={tabData.tab} key={tabData.key}>
            <StyledPayoutTabsPageWrapper>
              <Row gutter={[39, 50]} style={{marginTop: "1.5rem"}}>
                <Col xl={{span: 24}} style={{width: "100%"}}>
                  {tabData.content}
                </Col>
              </Row>
            </StyledPayoutTabsPageWrapper>
          </Tabs.TabPane>
        ))}
      </Tabs>
    </StyledPayoutTabsWrapper>
  );
}
